<router-outlet />

<app-confirmation-dialog />
<app-toast />
<app-loading-indicator />
